import { render, staticRenderFns } from "./collapsibleCard.vue?vue&type=template&id=df6d7668&scoped=true&"
import script from "./collapsibleCard.vue?vue&type=script&lang=js&"
export * from "./collapsibleCard.vue?vue&type=script&lang=js&"
import style0 from "./collapsibleCard.vue?vue&type=style&index=0&id=df6d7668&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df6d7668",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df6d7668')) {
      api.createRecord('df6d7668', component.options)
    } else {
      api.reload('df6d7668', component.options)
    }
    module.hot.accept("./collapsibleCard.vue?vue&type=template&id=df6d7668&scoped=true&", function () {
      api.rerender('df6d7668', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/transports/views/my/collapsibleCard.vue"
export default component.exports